import SectionHeading from '@/pages/home/components/SectionHeading';
import { highlights, stats } from '@/mocks/content';

export default function Intro() {
  return (
    <section id="intro" className="py-12 md:py-16 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-6 dv-reveal">
            <SectionHeading
              kicker="本站简介"
              title="一份帮你看明白「榴莲视频」的内容地图"
              desc="本站不播放视频，而是把分散的短视频、主播直播与长篇合集整理成清晰的结构。你不用在无数入口之间来回点击，打开这页就能知道今天有什么值得看、哪些主播在更新、完整版又藏在哪个合集里。"
            />
            <div className="mt-5 space-y-4 text-sm md:text-base leading-relaxed text-foreground-700">
              <p>
                页面的组织方式围绕三条主线展开：<strong className="font-semibold text-foreground-900">热门推荐</strong>
                负责回答「现在看什么」，按互动热度给出可直接点开的作品；
                <strong className="font-semibold text-foreground-900">福利主播</strong>
                负责回答「追谁」，把不同赛道的主播放在同一张榜单里比较；
                <strong className="font-semibold text-foreground-900">无删减合集</strong>
                负责回答「怎么一次看够」，把长篇内容按主题打包。
              </p>
              <p>
                每一项内容都标注了类型、时长与热度，卡片信息足够你在一屏之内做出判断。如果你想更进一步，社区讨论区里还有同好补充的背景资料与观感记录，很多细节都是被讨论出来的。
              </p>
            </div>
          </div>

          <div className="lg:col-span-6 dv-reveal">
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {stats.map((item) => (
                <div
                  key={item.id}
                  className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 transition-colors hover:border-primary-300"
                >
                  <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-lg">
                    <i className={item.icon} />
                  </span>
                  <p className="mt-3 font-heading text-2xl md:text-3xl font-black text-foreground-950">
                    {item.value}
                  </p>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {highlights.map((item, index) => (
            <article
              key={item.id}
              className={`rounded-lg border p-5 transition-transform duration-300 hover:-translate-y-1 dv-reveal ${
                index === 0
                  ? 'border-accent-300 bg-accent-50'
                  : 'border-background-200 bg-background-50'
              }`}
            >
              <span
                className={`w-10 h-10 flex items-center justify-center rounded-md text-xl ${
                  index === 0 ? 'bg-accent-500 text-background-50' : 'bg-secondary-100 text-secondary-800'
                }`}
              >
                <i className={item.icon} />
              </span>
              <h3 className="mt-3.5 font-heading text-base md:text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}